import PricingCatelogs from "./PricingCatelogs";

export default PricingCatelogs;
